import { useAccount } from '@hcs/authn';
import { CapabilityKeys } from '@hcs/types';

import { useCapabilityCheckForUser } from './useCapabilityCheckForUser';

export const useCapabilityCheck = (capabilityKey: CapabilityKeys) => {
  const accountQuery = useAccount();
  return useCapabilityCheckForUser(accountQuery.data?.user.id, capabilityKey);
};
